import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CashierState } from '../../source/appstates/cashierstates/cashierState';
import { LoginState } from '../../source/appstates/loginstates/loginState';
import { PlayerGetProfile } from '../../source/appstates/playerstates/playerActions';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { TrasactionHistory } from '../../source/modules/cashier/trasactionhistory';
import * as appState from '../../source/appstates/appState'
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions'
import moment from 'moment';
import { CommonModule, SlicePipe } from '@angular/common';
import { ReplacePipe } from '../../pipes/replace.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { Meta, Title } from '@angular/platform-browser';
import { CommondataService } from '../../source/services/games/commondata.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-transaction-history',
  standalone: true,
  imports: [CommonModule,TranslateModule, ReactiveFormsModule, ReplacePipe, NgxPaginationModule, FormsModule, SlicePipe, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
    MatDatepickerModule, MatNativeDateModule,],
  templateUrl: './transaction-history.component.html',
  styleUrl: './transaction-history.component.css'
})
export class TransactionHistoryComponent implements OnInit {
  // providers: [DatePipe]
  private storeSub!: Subscription;
  TrasactionHistory!: TrasactionHistory;
  transactiondata: any;
  typeForm!: FormGroup;
  form!: FormGroup;
  selectedType: any = [];
  formNew!: FormGroup;
  dateObj: any;
  typeArray = ['Deposits', 'Cashout']
  errormessage: string = "";
  types = [
    {
      language: 'Deposits',
      senttype: "Deposits",
      isChecked: true
    },
    {
      language: 'Cashout',
      senttype: "Cashout",
      isChecked: true
    },
  ];
  typesValue = "Deposit,Cashout"
  startDate!: Date;
  endDate!: Date;
  steddate: any;
  todaydate: any;
  profile: string = "";
  p: number = 1;
  q: number = 1;
  selectnum: number = 25;
  selectnumber: number = -25;
  cashselectnum: number = 25;
  itemsperpagecount = [
    { num: 25 },
    { num: 40 },
    { num: 50 },
    { num: 75 },
    { num: 99 },
  ];
  itemsperpagecountcash = [
    { num: 25 },
    { num: 40 },
    { num: 50 },
    { num: 75 },
    { num: 99 },
  ];
  lang: any
  showCashoutTable: boolean = false;
  showDepositTable: boolean = false;
  depositTransactiondata: any = [];
  cashoutTransactiondata: any;
  loginSub: Subscription;
  playerLoggedIn: boolean = false;
  loader: boolean = true;
  status = "";
  constructor(private store: Store<appState.AppState>, private translate:TranslateService, private comman:CommondataService, private router: Router, private fb: FormBuilder, private cdr: ChangeDetectorRef, private _adapter: DateAdapter<any>, private meta: Meta, private title: Title) {
    this._adapter.setLocale('en-GB');
    window.scroll(0, 440)

    this.store.dispatch(new cashierActions.CashierGetBalanceStart());
    this.store.dispatch(new PlayerGetProfile());

    this.store.dispatch(new cashierActions.ResetState())
    this.loginSub = this.store
      .select("loginState")
      .subscribe((loginState: LoginState) => {
        if (loginState.playerLoggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
        }
        if (!this.playerLoggedIn) {
          this.router.navigate(["/home"]);
        }
      });
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.typeForm = this.fb.group({
      typesValue: this.fb.array([])
    })

    this.translate.get('TRANSACTION_HISTORY_TITLE').subscribe(res => {
      this.title.setTitle(res);
      this.meta.updateTag({ property: 'og:title', content: res });
    });
    
    this.translate.get('TRANSACTION_HISTORY_DESCRIPTION').subscribe(res => {
      this.meta.updateTag({ name: 'description', content: res });
      this.meta.updateTag({ property: 'og:description', content: res });
    });
    

    this.todaydate = moment(new Date()).format('YYYY-MM-DD');
    this.profile = sessionStorage.getItem('profile') || "";
    this.endDate = new Date();
    let today = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate() - 7);
    this.startDate = today;

    this.form = new FormGroup({
      "currency": new FormControl(sessionStorage.getItem('wallet')),
      "startDate": new FormControl(null, Validators.required),
      "endDate": new FormControl(null, Validators.required),
      "limit": new FormControl("1000"),
      "index": new FormControl("0"),
      "type": new FormControl(this.typesValue, Validators.required)
    })

    this.formNew = new FormGroup({
      "currency": new FormControl(sessionStorage.getItem('wallet')),
      "startDate": new FormControl(null, Validators.required),
      "endDate": new FormControl(null, Validators.required),
      "limit": new FormControl("1000"),
      "index": new FormControl("0"),
      // "type": new FormControl(this.typesValue, Validators.required)
    })
    this.form.valueChanges.subscribe((x: any) => {
      let yearsDiff = 0;
      var ToDate = new Date();
      var pastYear = ToDate.getFullYear() - yearsDiff;
      ToDate.setFullYear(pastYear);
      if (new Date(x.startDate).getTime() > ToDate.getTime() || new Date(x.startDate).getTime() > new Date(x.endDate).getTime() || new Date(x.endDate).getTime() > ToDate.getTime()) {
        this.steddate = true;
        this.errormessage = "";
      } else {
        this.steddate = false;
      }
    });
    this.storeSub = this.store.select("cashierState").subscribe(
      (cashierState: CashierState) => {
        this.transactiondata = ''
        this.depositTransactiondata = ''
        this.cashoutTransactiondata = ''
        this.showCashoutTable = false;
        this.showDepositTable = false;
        if (cashierState.TrasactionHistory) {
          if (cashierState.TrasactionHistory.success == true) {
            this.errormessage = "";
            // this.comman.hideLoader()
             this.loader = false

            this.selectedType.find((type: any) => {
              if (type == 'Deposits') {
                if (cashierState.TrasactionHistory) {
                  if (cashierState.TrasactionHistory.deposits.length) {
                    this.showDepositTable = true;
                    let depositsData = cashierState.TrasactionHistory.deposits;
                    this.depositTransactiondata = depositsData.map((item: any) => {
                      const updatedStartDate = item.startDate?.replaceAll('T', ' ');
                      // if (item.status && item.status === 'Locked') {
                      //   return { ...item, status: 'failed', startDate: updatedStartDate };
                      // }
                      return { ...item, startDate: updatedStartDate };
                    });
                  } else if (cashierState.TrasactionHistory.deposits.length == 0) {
                    this.errormessage = 'NO_DEPOSIT_HISTORY';
                    this.showDepositTable = false;
                  }
                }
              }
              if (type == 'Cashouts') {
                if (cashierState.TrasactionHistory) {
                  if (cashierState.TrasactionHistory.cashouts.length) {
                    this.showCashoutTable = true;
                    let cashoutData = cashierState.TrasactionHistory.cashouts;
                    let updatedCashoutData = cashoutData.map((item) => {
                      const updatedcreatedDate = item.createdOn?.replaceAll('T', ' ');
                      return { ...item, createdOn: updatedcreatedDate };
                    });
                    this.cashoutTransactiondata = updatedCashoutData;
                  } else if (cashierState.TrasactionHistory.cashouts.length == 0) {
                    this.errormessage = 'NO_WITHDRAWAL_HISTORY';
                    this.showCashoutTable = false;
                  }
                }
              }
            })
          } else if (cashierState.TrasactionHistory.success == false) {
            // this.comman.hideLoader()
             this.loader = false
            this.transactiondata = "";
            if (cashierState.TrasactionHistory.description)
              if (cashierState.TrasactionHistory.description === "TECHNICAL_ERROR" || cashierState.TrasactionHistory.description === "failed to get transaction history with given input")
                this.errormessage = 'THERE_IS_NO_HISTORY_FOR_THE_SELECTED_PERIOD';
            this.depositTransactiondata = ''
            this.cashoutTransactiondata = ''
            this.showCashoutTable = false;
            this.showDepositTable = false;
          }
        }
        if (cashierState.TrasactionHistoryerror) {
          this.transactiondata = "";
          this.errormessage = cashierState.TrasactionHistoryerror.message;
        }
      })
    this.onChangetype("Deposits", true);
    this.cdr.detectChanges();
    this.onFormSubmit()
  }
  onChangetype(typesValue: string, isChecked: any) {
    this.loader = true
    this.depositTransactiondata = [];
    this.cashoutTransactiondata = [];
    this.errormessage = '';
    this.selectedType = []
    this.selectedType.push(typesValue)
  }

  onFormSubmit() {
    if (this.selectedType == '') {
      this.errormessage = 'PLEASE_SELECT_OPTION';
      this.depositTransactiondata = ''
      this.cashoutTransactiondata = ''
      this.showCashoutTable = false;
      this.showDepositTable = false;
    } else {
      const body = {
        currency: this.formNew.value.currency,
        startDate: moment(this.form.value.startDate).format('DD-MM-YYYY'),
        endDate: moment(this.form.value.endDate).format('DD-MM-YYYY'),
        limit: this.formNew.value.limit,
        index: this.formNew.value.index,
        type: this.selectedType.toString()
      };

      this.store.dispatch(new cashierActions.CashierGetBalanceStart());
      this.store.dispatch(new cashierActions.CashierTransactionHistory(body));
      // this.comman.showLoader()
      this.loader = true
    }
  }

  toFixed(data: any) {
    let num = Number(data);
    return num.toFixed(2)
  }
  onChangehisti(data: any) {
    this.p = 1;
    this.selectnum = data.target.value;
  }
  cashChange(data: any) {
    this.q = 1;
    this.cashselectnum = data.target.value;
  }

}
